import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryFeeExemptionUnlicensed: BlogMetaData = {
  title: '認可外保育園の補助金・助成金｜無償化4.03万円の対象条件と申請方法',
  description:
    '認可外保育園の補助金・助成金は国の無償化（3〜5歳は月4.03万円）が基本です。無償化とは別に自治体独自の補助制度がある地域もあり、神戸市の現状・申請条件・手続きの流れまでまとめて解説します。',
  thumbnailUrl: '/img/blog-nursery-fee-exemption-unlicensed.webp',
  filePath: buildBlogFilePath('nursery-fee-exemption-unlicensed'),
  category: BLOG_CATEGORY.NURSERY,
};
